import { render, staticRenderFns } from "./UserManualHistory.vue?vue&type=template&id=0fefa314&lang=html"
import script from "./UserManualHistory.vue?vue&type=script&lang=js"
export * from "./UserManualHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports